// Booking backend configuration.
// Override per-environment with a .env file (see .env.example). CRA only exposes
// variables prefixed with REACT_APP_ to the browser bundle.
export const API_BASE_URL = (
  process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000/v1'
).replace(/\/$/, '');

// The tenant's slug in the appointments system (NOT the raw tenant id — the
// public API exchanges this slug for a scoped guest token on load).
export const TENANT_SLUG = process.env.REACT_APP_TENANT_SLUG || 'acme';

// How many days ahead to look for availability.
export const AVAILABILITY_WINDOW_DAYS = 14;
